import React, { lazy } from 'react';
import { useRoutes } from 'react-router-dom';
import { wrapUseRoutesV6 } from '@sentry/react';

import MainLayout from './MainLayout';
const Map = lazy(() => import('./pages/Map'));
const Report = lazy(() => import('./pages/Report'));
const UnauthReport = lazy(() => import('./pages/UnauthReport'));
const RouteReport = lazy(() => import('./pages/RouteReport'));
const UnauthRouteReport = lazy(() => import('./pages/UnauthRouteReport'));

const routeConfig = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: 'report/:reportGuid',
        element: <Report />,
      },
      {
        path: 'route-report/:reportGuid',
        element: <RouteReport />,
      },
      {
        path: 'unauth-report/:reportGuid',
        element: <UnauthReport />,
      },
      {
        path: 'unauth-route-report/:reportGuid',
        element: <UnauthRouteReport />,
      },
      {
        path: '/',
        element: <Map />,
      },
      {
        path: '*',
        element: <Map />,
      },
    ],
  },
];

export const Routes = () => {
  const useSentryRoutes = wrapUseRoutesV6(useRoutes);
  const element = useSentryRoutes(routeConfig);

  return <>{element}</>;
};

export default Routes;
